import { AxiosRequestConfig } from "axios";
import myaxios from "lib/myAxios";
import { useCallback, useState } from "react";

export default function usePost<T>(
  url: string | null,
  filterMode?: boolean,
  body?: any,
) {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<T>();
  const [error, setError] = useState({ hasOccurred: false, message: "" });
  const post = useCallback(
    (body_?: any) => {
      setIsLoading(true);
      if (url)
        myaxios({
          method: "POST",
          url: url,
          data: body_ ?? body ?? {},
        } as AxiosRequestConfig)
          .then(({ data: { data, message, success } }) => {
            if (success) {
              filterMode ? setData(data.results) : setData(data);
            } else setError({ hasOccurred: true, message });
            setIsLoading(false);
          })
          .catch(({ response }) => {
            let message;
            if (response) message = response.data.message;
            setError({ hasOccurred: true, message });
            setIsLoading(false);
          });
    },
    [body, url, filterMode],
  );

  return { data, isLoading, error, post };
}
